/* global translations */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import popup from '../../../legacy/app/popup';
import MemberStore from '../../stores/MemberStore';
import ImageSvg from '../image/ImageSvg';
import MembersActionCreators from '../../actions/MembersActionCreators';
// import modal from '../../../legacy/app/modal';

const ReactPropTypes = PropTypes;

class MemberMenu extends React.Component {
  member = MemberStore.get(this.props.memberId);

  //
  state = {
    member: this.member,
    ignored: this.member.ignored,
    blocked: this.member.blocked,
    favorite: this.member.favorite,
    winked: false,
  };

  /**
   * Handler for 'onClickBlockAction'
   */
  onClickBlockAction = (e) => {
    e.preventDefault();

    const { blocked } = this.state;
    const confirmText = blocked ? 'txt: Vai tiešām atbloķēt?' : 'txt: Vai tiešām bloķēt?';

    // modal.confirm(translations[confirmText], (response) => {
    this.props.showDialog(translations[confirmText], (response) => {
      if (!response) {
        return;
      }

      const { memberId } = this.props;
      if (blocked) {
        MembersActionCreators.unblock(memberId);
      } else {
        MembersActionCreators.block(memberId);
      }

      this.setState({ blocked: !blocked });
    });
  };

  onClickIgnore = (e) => {
    e.preventDefault();

    const { ignored } = this.state;
    const confirmText = ignored ? 'txt: Vai tiešām rādīt meklētājā?' : 'txt: Vai tiešām nerādīt meklētājā?';

    // modal.confirm(translations[confirmText], (response) => {
    this.props.showDialog(translations[confirmText], (response) => {
      if (!response) {
        return;
      }

      const { memberId } = this.props;
      if (ignored) {
        MembersActionCreators.unignore(memberId);
      } else {
        MembersActionCreators.ignore(memberId);
      }

      this.setState({ ignored: !ignored });
    });
  };

  onClickWink = (e) => {
    e.preventDefault();

    if (get(globals, 'currentMember.vipOn', false)) {
      popup.vipOnMessage();
      return;
    }

    if (!get(globals, 'currentMember.subscription', false)) {
      popup.subscriptionMessage();
      return;
    }

    if (this.state.winked) {
      return;
    }

    MembersActionCreators.wink(this.props.memberId);
    this.setState({ winked: true });
  };

  onClickFavorite = (e) => {
    e.preventDefault();

    const { memberId } = this.props;
    const { favorite } = this.state;

    if (favorite) {
      MembersActionCreators.removefavorite(memberId);
    } else {
      MembersActionCreators.addfavorite(memberId);
    }

    this.setState({ favorite: !favorite });
  };

  render() {
    const {
      member,
      ignored,
      blocked,
      winked,
      favorite,
    } = this.state;

    const {
      menuItems,
      memberId,
      fullOpacity,
    } = this.props;

    const self = this;
    const memberMenuItems = [];

    // Ignore/unignore
    if (menuItems.indexOf('ignore') !== -1) {
      memberMenuItems.push([
        <div
          role="presentation"
          key="memberMenuItemIgnore"
          onClick={self.onClickIgnore}
          className={`btn ${ignored ? 'btn--a' : 'btn--dangerOnHover'} btn--smallOneIcon tooltip tooltip--right tooltip--big memberMenu-block`}
          data-tooltip={translations[ignored ? 'txt: Rādīt meklētājā' : 'txt: Nerādīt meklētājā']}
          data-post="true"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg={ignored ? 'icon-find' : 'icon-zoomout'}
                  iconClass={ignored ? 'icon--find' : 'icon--zoomOut'}
                />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    // Block/unblock
    if (menuItems.indexOf('block') !== -1) {
      memberMenuItems.push([
        <div
          role="presentation"
          key="memberMenuItemBlock"
          onClick={self.onClickBlockAction}
          className={`btn ${blocked ? 'btn--a' : 'btn--dangerOnHover'} btn--smallOneIcon tooltip tooltip--right tooltip--big memberMenu-block`}
          data-tooltip={translations[blocked ? 'txt: Atbloķēt šo lietotāju' : 'txt: Bloķēt šo lietotāju']}
          data-post="true"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg={blocked ? 'icon-profile-4' : 'icon-ignore'}
                  iconClass={blocked ? 'icon--profile-4' : 'icon--ignore'}
                />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    // Wink
    if (menuItems.indexOf('wink') !== -1) {
      memberMenuItems.push([
        <div
          role="presentation"
          key="memberMenuItemWink"
          onClick={self.onClickWink}
          className={`btn btn--a btn--smallOneIcon tooltip tooltip--left tooltip--big memberMenu-block${winked ? ' btn--disabled' : ''}`}
          data-tooltip={translations[winked ? 'txt: Tu piemiedzi ar aci {:target}' : 'txt: Piemiegt ar aci'].replace('{:target}', '')}
          data-post="true"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg="icon-wink" iconClass="icon--wink" />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    // Add/remove from favorites
    if (menuItems.indexOf('favorite') !== -1) {
      memberMenuItems.push([
        <div
          role="presentation"
          key="memberMenuItemFavorite"
          onClick={self.onClickFavorite}
          className={`btn ${favorite ? 'btn--dangerOnHover' : 'btn--a'} btn--smallOneIcon tooltip tooltip--left tooltip--big memberMenu-block`}
          data-tooltip={translations[favorite ? 'txt: Dzēst favorītu' : 'txt: Pievienot favorītiem']}
          data-post="true"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg={favorite ? 'icon-heartremove' : 'icon-heartadd'}
                  iconClass={favorite ? 'icon--heartRemove' : 'icon--heartAdd'}
                />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    // Approve (for admin)
    if (menuItems.indexOf('approve') !== -1) {
      memberMenuItems.push([
        <div
          id={`approveMember_${memberId}`}
          key="memberMenuItemApprove"
          className="btn btn--b btn--smallOneIcon tooltip tooltip--left tooltip--big memberMenu-block admin-memberApproveBtn"
          data-tooltip="Approve member"
          data-post="true"
          data-id={memberId}
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">&#10003;</span>
            </span>
          </span>
        </div>,
      ]);
    }

    // Remove profile img (for admin)
    if (menuItems.indexOf('remove_profile_img') !== -1) {
      const deleteHref = `/images/remove_profile/1/${memberId}`;
      memberMenuItems.push([
        <div
          key="memberMenuItemRemoveImage"
          data-href={deleteHref}
          className="btn btn--b btn--smallOneIcon tooltip"
          data-tooltip="Remove img"
          data-confirm="true"
          data-confirm-dont-hide="true"
          data-confirm-msg="Are you sure?"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg="icon-close"
                  iconClass="icon--close"
                />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    // Delete (for admin)
    if (menuItems.indexOf('delete') !== -1) {
      const deleteHref = `/member/${memberId}/change_status?lietotaja_status=deleted`;
      memberMenuItems.push([
        <div
          key="memberMenuItemDeleteMember"
          data-href={deleteHref}
          className="btn btn--b btn--smallOneIcon tooltip"
          data-tooltip="Delete user"
          data-confirm="true"
          data-confirm-dont-hide="true"
          data-confirm-msg="Are you sure?"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg="icon-trash"
                  iconClass="icon--trash"
                />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    if (menuItems.indexOf('ban') !== -1) {
      const banHref = `/member/${memberId}/change_status?lietotaja_status=banned`;
      memberMenuItems.push([
        <div
          key="memberMenuItemBanMember"
          data-href={banHref}
          className="btn btn--b btn--smallOneIcon tooltip"
          data-tooltip="Ban user"
          data-confirm="true"
          data-confirm-dont-hide="true"
          data-confirm-msg="Are you sure?"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg
                  svg="icon-ignore"
                  iconClass="icon--ignore"
                />
              </span>
            </span>
          </span>
        </div>,
      ]);
    }

    return (
      <div className={`memberMenu${fullOpacity ? ' memberMenu--fullOpacity' : ''}`}>
        {(menuItems.indexOf('score') !== -1) && (
          <div
            key="memberMenuItemFirst"
            className="memberMenu-score tooltip fl"
            data-tooltip={translations['txt: Anketa']}
          >
            <span className="memberMenu-score-text">
              {`${member.answer_score} %`}
            </span>
          </div>
        )}
        <div className="memberMenu-items">{memberMenuItems}</div>
      </div>
    );
  }
}

MemberMenu.propTypes = {
  memberId: ReactPropTypes.string,
  menuItems: PropTypes.arrayOf(PropTypes.string),
  fullOpacity: ReactPropTypes.bool,
  showDialog: ReactPropTypes.func.isRequired,
};

MemberMenu.defaultProps = {
  memberId: null,
  menuItems: [],
  fullOpacity: false,
};

module.exports = MemberMenu;
